var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "event-table",
      attrs: { id: "grid-wrapper", eventTableName: _vm.tableName },
    },
    [
      _c("ag-grid-vue", {
        staticClass: "ag-theme-alpine",
        staticStyle: { width: "100%", height: "100%" },
        attrs: {
          "column-defs": _vm.vendorOptions.columnDefs,
          "default-col-def": _vm.defaultColDef,
          "row-data": _vm.vendorOptions.data,
          "row-selection": _vm.vendorOptions.rowSelection,
          pagination: _vm.vendorOptions.withPagination,
          "pagination-page-size": _vm.vendorOptions.paginationPageSize,
          "pagination-auto-page-size": _vm.vendorOptions.paginationAutoPageSize,
          "get-row-height": _vm.currentRowHeight,
          "tooltip-show-delay": _vm.tooltipShowDelay,
          "animate-rows": _vm.animateRows,
        },
        on: {
          "sort-changed": _vm.onSortChanged,
          "cell-double-clicked": _vm.onCellDoubleClicked,
          "grid-ready": _vm.onGridReady,
          "row-selected": _vm.onRowSelected,
          paginationChanged: _vm.onPaginationChange,
          "first-data-rendered": _vm.onFirstDataRendered,
          "grid-size-changed": _vm.onGridSizeChanged,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }